import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import * as React from "react";
import Media from "react-media";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ReactSVG from "react-svg";
import { FormattedMessage } from "react-intl";
import { animated, useSpring } from "react-spring";
import { UserChannel, useAuth } from "@saleor/sdk";
import { xMediumScreen } from "@styles/constants";
import { useEffect } from "react";
import { Loader } from "@components/atoms";
import AlertRedirectWA from "@temp/components/AlertRedirectWA";
import { ChangeAmountProductsContext } from "@temp/contexts";
import NetworkStatus from "../../components/NetworkStatus";
import * as paths from "../../app/routes/paths";
import * as pathsDelivery from "../../app/routes/pathsDelivery";
import { signInType } from "../../constants";

var loginDeliveryman = require("../../images/loginDeliveryman.png");

var securityLogo = require("../../images/Seguridad.svg");

export var View = function View() {
  var _useAuth = useAuth(),
      signIn = _useAuth.signIn,
      loadUserCheckout = _useAuth.loadUserCheckout,
      isCurrentTokenValid = _useAuth.isCurrentTokenValid,
      user = _useAuth.user;

  var navigate = useNavigate();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      codeError = _React$useState2[0],
      setCodeError = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      messageError = _React$useState4[0],
      setMessageError = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      showRedirectModal = _React$useState8[0],
      setShowRedirectModal = _React$useState8[1];

  var _useParams = useParams(),
      userId = _useParams.userId,
      accessCode = _useParams.accessCode,
      tradeId = _useParams.tradeId,
      orderToken = _useParams.orderToken;

  var location = useLocation();
  var queryParams = new URLSearchParams(location.search);

  var _React$useContext = React.useContext(ChangeAmountProductsContext),
      maxProductsPerCategory = _React$useContext.maxProductsPerCategory;

  var logoMainTrade = queryParams.get("logo_url");
  var scaleButton = useSpring({
    config: {
      friction: 40,
      mass: 5,
      tension: 350
    },
    from: {
      scale: 1.1
    },
    loop: true,
    to: {
      scale: 1
    }
  });
  var cleanOrderSession = React.useCallback(function () {
    localStorage.removeItem("order_token");
  }, []);

  var initUrl = function initUrl() {
    switch (true) {
      case paths.waLoginOrderRegExp.test(location.pathname):
        cleanOrderSession();
        navigate("/status/".concat(orderToken), {
          replace: true
        });
        break;

      case paths.waLoginProfileRegExp.test(location.pathname):
        navigate(paths.accountUrl);
        break;

      case paths.waLoginOrdersRegExp.test(location.pathname):
        navigate(paths.orderHistoryUrl);
        break;

      case paths.waLoginOrdersInProgressRegExp.test(location.pathname):
        navigate(paths.orderInProgressUrl);
        break;

      case pathsDelivery.waDeliveryLoginRegExp.test(location.pathname):
        navigate(pathsDelivery.baseDeliveryUrl);
        break;

      case pathsDelivery.waDeliveryLoginOrderRegExp.test(location.pathname):
        navigate("/delivery/order/".concat(orderToken), {
          replace: true
        });
        break;

      case paths.waLoginRegExp.test(location.pathname):
      default:
        navigate(paths.baseUrl);
        break;
    }
  };

  var getSigninType = function getSigninType() {
    switch (true) {
      case paths.waLoginOrderRegExp.test(location.pathname):
        return signInType.orderDetail;

      case paths.waLoginProfileRegExp.test(location.pathname):
        return signInType.profile;

      case paths.waLoginOrdersRegExp.test(location.pathname):
        return signInType.ordersList;

      case paths.waLoginOrdersInProgressRegExp.test(location.pathname):
        return signInType.ordersList;

      case pathsDelivery.waDeliveryLoginRegExp.test(location.pathname):
        return signInType.normal;

      case pathsDelivery.waDeliveryLoginOrderRegExp.test(location.pathname):
        return signInType.orderDetail;

      case paths.waLoginRegExp.test(location.pathname):
      default:
        return signInType.normal;
    }
  };

  var tryToRemoveSessionData = function tryToRemoveSessionData() {
    window.removeStorage();
  };

  var getTradeKey = function getTradeKey() {
    switch (true) {
      case paths.waLoginRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
      case paths.waLoginOrderRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
        return tradeId;

      case paths.waLoginProfileRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
      case paths.waLoginOrdersRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
      case paths.waLoginOrdersInProgressRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
        return "USER";

      case pathsDelivery.waDeliveryLoginRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
      case pathsDelivery.waDeliveryLoginOrderRegExp.test(location === null || location === void 0 ? void 0 : location.pathname):
        return "DELIVERY";

      default:
        return null;
    }
  };

  var signInWa = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _user$lastChannel, _UserChannel$WHATSAPP;

      var userTradeKey, isCurrentAccessValid, _yield$isCurrentToken, isValid, _yield$loadUserChecko, executed, _yield$signIn, data, dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userTradeKey = "".concat(userId, "-").concat(getTradeKey());
              isCurrentAccessValid = false;

              if (!(localStorage.getItem("webAccess") === userTradeKey && (user === null || user === void 0 ? void 0 : (_user$lastChannel = user.lastChannel) === null || _user$lastChannel === void 0 ? void 0 : _user$lastChannel.toUpperCase()) === ((_UserChannel$WHATSAPP = UserChannel.WHATSAPP) === null || _UserChannel$WHATSAPP === void 0 ? void 0 : _UserChannel$WHATSAPP.toUpperCase()))) {
                _context.next = 16;
                break;
              }

              window.avoidRefreshSignInToken();
              setLoading(true);
              _context.next = 7;
              return isCurrentTokenValid();

            case 7:
              _yield$isCurrentToken = _context.sent;
              isValid = _yield$isCurrentToken.isValid;
              _context.next = 11;
              return loadUserCheckout(isValid);

            case 11:
              _yield$loadUserChecko = _context.sent;
              executed = _yield$loadUserChecko.executed;
              setLoading(false);
              window.allowRefreshSignInToken();
              isCurrentAccessValid = isValid && executed;

            case 16:
              if (!isCurrentAccessValid) {
                _context.next = 20;
                break;
              }

              initUrl();
              _context.next = 29;
              break;

            case 20:
              tryToRemoveSessionData();
              setLoading(true);
              _context.next = 24;
              return signIn(userId, accessCode, maxProductsPerCategory + 1, getSigninType());

            case 24:
              _yield$signIn = _context.sent;
              data = _yield$signIn.data;
              dataError = _yield$signIn.dataError;
              setLoading(false);

              if (dataError === null || dataError === void 0 ? void 0 : dataError.error) {
                setMessageError(dataError.error[0].message);
                setCodeError(dataError.error[0].code);
              } else if (data) {
                localStorage.setItem("webAccess", userTradeKey);
                initUrl();
              } else {
                setMessageError("Por favor discúlpanos 🙏🏻 🙏🏻, no pudimos acceder, " + "vuelve a Whatsapp e inténtalo de nuevo ");
              }

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function signInWa() {
      return _ref.apply(this, arguments);
    };
  }();

  var goToWa = function goToWa() {
    var userRole = location.pathname.includes("delivery") ? "DELIVERY_MAN" : "CUSTOMER";

    switch (userRole.toUpperCase()) {
      case "DELIVERY_MAN":
        window.open("".concat(pathsDelivery.urlOpenWhatsappDelivery, " &text=Hola%20quiero%20gestionar%20mis%20pedidos"), "_blank");
        break;

      default:
        window.open("".concat(paths.urlOpenWhatsapp, " &text=Hola%20quiero%20ingresar%20de%20nuevo"), "_blank");
        break;
    }
  };

  var handleContinue = React.useCallback(function () {
    var userRole = location.pathname.includes("delivery") ? "DELIVERY_MAN" : "CUSTOMER";

    switch (userRole.toUpperCase()) {
      case "DELIVERY_MAN":
        window.open("".concat(pathsDelivery.urlOpenWhatsappDelivery.replace("+", "%2B"), "&text&type=phone_number&app_absent=0"), "_blank");
        break;

      default:
        window.open("".concat(paths.urlOpenWhatsapp.replace("+", "%2B"), "&text&type=phone_number&app_absent=0"), "_blank");
        break;
    }
  }, []);
  useEffect(function () {
    if (codeError === "WA_WEB_ACCESS_EXPIRED") {
      setShowRedirectModal(true);
    }
  }, [codeError]);
  useEffect(function () {
    signInWa();
    return function () {};
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(NetworkStatus, null, function (isOnline) {
    return React.createElement(React.Fragment, null, messageError ? React.createElement(Media, {
      query: {
        maxWidth: xMediumScreen
      }
    }, function (matches) {
      return matches ? React.createElement("div", {
        className: "walogin__container"
      }, React.createElement("div", {
        className: "walogin__logo"
      }, React.createElement("div", {
        className: "walogin__logo__background"
      }, " "), React.createElement("span", {
        className: "walogin__logo__logo walogin__logo__logo_error"
      }, " ")), React.createElement(animated.button, {
        className: "walogin__logo__slogan walogin__logo__slogan__error",
        onClick: goToWa,
        style: scaleButton
      }, React.createElement("span", null, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.2516060933",
        defaultMessage: "Join with WhatsApp"
      }))), React.createElement("div", {
        className: "walogin__link_error"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.3208458154",
        defaultMessage: "Your link has expired"
      })), React.createElement("p", {
        className: "walogin__error_message"
      }, messageError), React.createElement("div", {
        className: "walogin__safe walogin__safe__error"
      }, React.createElement(ReactSVG, {
        path: securityLogo,
        className: "walogin__safe__icon"
      }), React.createElement("p", {
        className: "walogin__safe__text"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.291395769",
        defaultMessage: "100% Safe"
      })))) : React.createElement("div", {
        className: "waloginMax"
      }, React.createElement("div", {
        className: "waloginMax__background"
      }, " "), React.createElement("div", {
        className: "waloginMax__container"
      }, React.createElement("div", {
        className: "waloginMax__container__left"
      }, React.createElement("div", {
        className: "waloginMax__container__left__icon"
      }, React.createElement("span", {
        className: "waloginMax__container__left-imgEP waloginMax__container__left-imgEP_error"
      }, " ")), React.createElement(animated.button, {
        className: "waloginMax__container__left__slogan waloginMax__container__left__slogan__error",
        onClick: goToWa,
        style: scaleButton
      }, React.createElement("span", null, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.2516060933",
        defaultMessage: "Join with WhatsApp"
      }))), React.createElement("div", {
        className: "waloginMax__container__left__safe waloginMax__container__left__safe__error"
      }, React.createElement(ReactSVG, {
        path: securityLogo,
        className: "waloginMax__container__left__safe__icon"
      }), React.createElement("p", {
        className: "waloginMax__container__left__safe__text"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.291395769",
        defaultMessage: "100% Safe"
      })))), React.createElement("div", {
        className: "waloginMax__container__right"
      }, React.createElement("div", {
        className: "waloginMax__container__right__link_error"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.3208458154",
        defaultMessage: "Your link has expired"
      })), React.createElement("div", {
        className: "waloginMax__container__right__error_message"
      }, messageError))));
    }) : React.createElement(Media, {
      query: {
        maxWidth: xMediumScreen
      }
    }, function (matches) {
      return matches ? React.createElement("div", {
        className: "walogin__container"
      }, React.createElement("div", {
        className: "walogin__logo"
      }, React.createElement("div", {
        className: "walogin__containerLoad"
      }, React.createElement("span", {
        className: "walogin__logo__logoLoading"
      }, " "), React.createElement("div", {
        className: "walogin__logo__loading"
      }, loading ? React.createElement(Loader, null) : React.createElement(React.Fragment, null)), React.createElement("span", {
        className: "walogin__logo__logoLoading",
        style: {
          backgroundImage: location.pathname.includes("delivery") ? "url(".concat(loginDeliveryman, ")") : "url(".concat(logoMainTrade, ")")
        }
      }, " "))), React.createElement("div", {
        className: "walogin__security_politics"
      }, React.createElement("p", {
        className: "walogin__security_politics__bold"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.2457236988",
        defaultMessage: "Loading the establishment"
      }))), React.createElement("div", {
        className: "walogin__safe"
      }, React.createElement(ReactSVG, {
        path: securityLogo,
        className: "walogin__safe__icon"
      }), React.createElement("p", {
        className: "walogin__safe__text"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.291395769",
        defaultMessage: "100% Safe"
      }))), React.createElement("div", {
        className: "walogin__logo__backgroundImage"
      }, " ")) : React.createElement("div", {
        className: "waloginMax"
      }, React.createElement("div", {
        className: "waloginMax__container"
      }, React.createElement("div", {
        className: "waloginMax__container__left"
      }, React.createElement("div", {
        className: "waloginMax__container__left__containerLoad"
      }, React.createElement("span", {
        className: "waloginMax__container__right-imgLoad"
      }, " "), React.createElement("div", {
        className: "waloginMax__container__right__loading"
      }, loading ? React.createElement(Loader, null) : React.createElement(React.Fragment, null)), React.createElement("span", {
        className: "waloginMax__container__left-img",
        style: {
          backgroundImage: location.pathname.includes("delivery") ? "url(".concat(loginDeliveryman, ")") : "url(".concat(logoMainTrade, ")")
        }
      }, " ")), React.createElement("div", {
        className: "waloginMax__container__right__security_politics"
      }, React.createElement("p", {
        className: "waloginMax__container__right__security_politics__bold"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.2457236988",
        defaultMessage: "Loading the establishment"
      }))), React.createElement("div", {
        className: "waloginMax__container__right__safe"
      }, React.createElement(ReactSVG, {
        path: securityLogo,
        className: "waloginMax__container__right__safe__icon"
      }), React.createElement("p", {
        className: "waloginMax__container__right__safe__text"
      }, React.createElement(FormattedMessage, {
        id: "views.WaLogin.View.291395769",
        defaultMessage: "100% Safe"
      })))), React.createElement("div", {
        className: "waloginMax__container__right"
      }, React.createElement("div", {
        className: "waloginMax__backgroundImage"
      }, " "))));
    }));
  }), showRedirectModal && React.createElement(AlertRedirectWA, {
    hideModal: function hideModal() {
      return setShowRedirectModal(false);
    },
    handleContinue: handleContinue
  }));
};
export default View;